import {
  ActivatedRouteSnapshot,
  ResolveFn,
} from '@angular/router';
import { ReportFormStore } from '../reports/services';
import { inject } from '@angular/core';
import { GeneralTabDto } from '@fdm/api-client';

export const actionItemResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const store = inject(ReportFormStore);
  const id = route.queryParamMap.get('generalTabId')!;

  store.setGeneral(GeneralTabDto.fromJS({ id }));

  return id;
};
